import { css } from '@emotion/core'
import styled from '@emotion/styled'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { NativeLink, palette, Text, TextWithLinks } from 'main/ui'

const styles = css`
  font-size: 13px;
  line-height: 20px;
`

const StyledText = styled(Text)`
  ${styles}

  color: ${palette.slate};
`

const StyledNativeLink = styled(NativeLink)(styles)
const PRE = 'MAIN-COMMON-AUTH-MODAL-TERMS'

function Terms() {
  const { t } = useTranslation(NAMESPACE)
  const { isWhitelabeled, i18nSuffix: suffix } = useWhitelabel()

  return (
    <>
      {!isWhitelabeled && (
        <div>
          <StyledText>{t(`${PRE}-TEXT`)}</StyledText>
          <StyledNativeLink href="/terms-of-use" target="_blank">
            {t(`${PRE}-USE`)}
          </StyledNativeLink>
          <StyledText>{t(`${PRE}-AND`)}</StyledText>
          <StyledNativeLink href="/privacy-policy" target="_blank">
            {t(`${PRE}-PRIVACY`)}
          </StyledNativeLink>
          <StyledText>.</StyledText>
        </div>
      )}
      {isWhitelabeled && (
        <TextWithLinks>
          {t(`LOGIN-PAGE-TOS-PRIVACY-DISCLAIMER${suffix}`, {
            ws_eli_tos: 'https://corp.wonderschool.com/eli-terms',
            ws_eli_privacy: 'https://corp.wonderschool.com/eli-privacy',
            eli_tos: 'https://theearlylearningmarketplace.org/terms/',
            eli_privacy: 'https://theearlylearningmarketplace.org/privacy/',
          })}
        </TextWithLinks>
      )}
    </>
  )
}

export default React.memo(Terms)
